import React from 'react';
import { CopyableText } from 'modules/Common/Copy';

import ShipperOrderCircle from '../ShipperOrderCircle';

import StyledHeaderRow from './StyledHeaderRow';

import { injectIntl } from 'react-intl';

import { IS_TENANT } from 'tenant/config';

const maxNumberOfOrderBalls = 8;

const HeaderRow = ({ stopId, shipperOrdersSkin = {}, stop, displayJourney, intl }) => {
  const t = intl.messages.components.StopCard;
  const types = {
    PICKUP: t.types.PICKUP,
    DROPOFF: t.types.DROPOFF,
  };
  const { stop_type, shipper_order_id, journey_id, store, shipper_orders, isAggregated } =
    stop || {};

  const stopNumber = stopId + 1;
  const isGroupage = Object.keys(shipperOrdersSkin || {}).length > 1;
  const shipperOrders = shipper_orders || [];

  const shouldShowShipperOrderId = !isAggregated && !displayJourney && isGroupage && !store;
  const shouldShowJourneyId = !isAggregated && displayJourney && !!journey_id && !isGroupage;

  const acceptance_locator_code = stop
    ? (
        [...(stop.load_pickup || []), ...(stop.load_dropoff || [])].filter(
          (l) => l.acceptance_locator_code
        )[0] || {}
      ).acceptance_locator_code
    : '';
  const release_locator_code = stop
    ? (
        [...(stop.load_pickup || []), ...(stop.load_dropoff || [])].filter(
          (l) => l.release_locator_code
        )[0] || {}
      ).release_locator_code
    : '';
  return (
    <StyledHeaderRow
      skin={shipperOrdersSkin[shipper_order_id]}
      isAggregated={isAggregated}
      store={store}
    >
      <span className="header-row__stop-id">{stopNumber}</span>
      <span className="header-row__stop-type">
        {types[stop_type]} {!!store && <>({store})</>}
      </span>
      {shouldShowShipperOrderId && (
        <div className="header-row__entity-id">
          <CopyableText text={`S${shipper_order_id}`} />
        </div>
      )}
      {shouldShowJourneyId && (
        <div className="header-row__entity-id">
          <CopyableText text={`J${journey_id}`} />
        </div>
      )}
      {isAggregated && (
        <div className="header-row__orders-parent">
          {shipperOrders.length > maxNumberOfOrderBalls ? (
            <>{shipperOrders.length} SOs</>
          ) : (
            shipperOrders.map((shipperOrder) => (
              <ShipperOrderCircle
                key={shipperOrder.id}
                skin={shipperOrdersSkin[shipperOrder.id]}
                data-testid="shipper-order-ball"
              />
            ))
          )}
        </div>
      )}
      {IS_TENANT && (
        <div className="header-row__locator-parent">
          <span>{stop_type === 'PICKUP' ? acceptance_locator_code : release_locator_code}</span>
        </div>
      )}
    </StyledHeaderRow>
  );
};

export default injectIntl(HeaderRow);
